type QueryValue = string | number | boolean | Date;
type QueryParam = QueryValue | QueryValue[] | null | undefined;

function shouldSkip(value: QueryParam): value is null | undefined {
  return (
    value === null ||
    value === undefined ||
    value === "" ||
    (typeof value === "number" && Number.isNaN(value))
  );
}

function toParamString(value: QueryValue): string {
  if (value instanceof Date) {
    return value.toISOString();
  }
  return String(value);
}

/**
 * Creates a query string with consistent handling for arrays and empty values.
 */
export function buildQueryString(
  params: Record<string, QueryParam>
): string {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (!shouldSkip(item)) {
          searchParams.append(key, toParamString(item));
        }
      });
      return;
    }

    if (shouldSkip(value)) {
      return;
    }

    searchParams.set(key, toParamString(value));
  });

  const query = searchParams.toString();
  return query ? `?${query}` : "";
}
